module.exports = __webpack_public_path__ + "static/media/anas.8e957418.jpg";